import styled from "styled-components";

export const PayeWrapper = styled("div")(() => {
  return {
    position: "relative",
    padding: 0,
    display: "grid",
    gap: "1.5rem",
    "& .payment-modal": {
      position: "fixed",
      top: "50%",
      left: "50%",
      height: "auto",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#FFFFFF",
      padding: "calc(var(--cardPadding) * 1)",
      borderRadius: "1rem",
      boxShadow: "0px 20px 24px -4px #10182814",
      "& .payment-form": {
        alignItems: "unset",
        justifyContent: "unset",
        padding: "unset",
      },
      "@media screen and (max-width: 425px)": {
        top: "50%",
        left: "50%",
        right: 0,
        bottom: 0,
        transform: "translate(-50%, -50%)",
        borderRadius: "0.9rem",
        width: "85%",
      },
    },
    "& .error-box": {
      padding: "0",
      "& p": {
        marginBlock: 0,
      },
    },
    "& .export-button-area": {
      display: "flex",
      justifyContent: "flex-end",
    },
  };
});

export const PayeFilterCard = styled("section")(() => {
  return {
    "--filter-control-height": "3rem",
    border: "1px solid #e5e7eb",
    borderRadius: "0.85rem",
    backgroundColor: "var(--color-primary-hover)",
    padding: "1rem",
    display: "grid",
    gap: "1rem",
    "& .filter-title": {
      margin: 0,
      display: "inline-flex",
      alignItems: "center",
      gap: "0.45rem",
      fontFamily: "Poppins",
      color: "var(--color-text-light)",
      fontSize: "0.78rem",
      letterSpacing: "0.07em",
      textTransform: "uppercase",
      fontWeight: 700,
    },
    "& .filter": {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gridTemplateAreas: `
        "start-year start-month export"
        "end-year end-month ."
      `,
      alignItems: "end",
      gap: "1rem",
      "& fieldset": {
        overflow: "hidden",
      },
      "& > fieldset:nth-of-type(1)": {
        gridArea: "start-year",
      },
      "& > fieldset:nth-of-type(2)": {
        gridArea: "start-month",
      },
      "& > fieldset:nth-of-type(3)": {
        gridArea: "end-year",
      },
      "& > fieldset:nth-of-type(4)": {
        gridArea: "end-month",
      },
      "& .export-button-area": {
        gridArea: "export",
        width: "100%",
        justifyContent: "stretch",
        alignSelf: "end",
      },
      "& label": {
        fontFamily: "Poppins",
        fontWeight: 600,
        fontSize: "0.8rem",
        color: "var(--color-primary)",
        textTransform: "uppercase",
        letterSpacing: "0.05em",
        marginBottom: "0.45rem",
        display: "inline-block",
      },
      "& select": {
        padding: "0.7rem 0.8rem",
        minHeight: "var(--filter-control-height)",
        borderRadius: "0.45rem",
        border: "1px solid #d9dee7",
        fontWeight: "400",
        color: "var(--color-text)",
        backgroundColor: "var(--color-neutral)",
        "&:focus": {
          outline: "none",
          border: "none",
        },
      },
      "@media screen and (max-width: 768px)": {
        gridTemplateColumns: "1fr",
        gridTemplateAreas: `
          "start-year"
          "start-month"
          "export"
          "end-year"
          "end-month"
        `,
      },
    },
    "& .export-button-area > div": {
      display: "flex",
      height: "100%",
      width: "100%",
    },
    "& .export-table-btn": {
      minHeight: "var(--filter-control-height)",
      height: "var(--filter-control-height)",
      display: "inline-flex",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 1rem",
      borderRadius: ".45rem",
      transition: "background-color 0.2s ease",
      "&:hover": {
        backgroundColor: "#1f5620",
      },
    },
  };
});

export const PayeTableCard = styled("div")(() => {
  return {
    border: "1px solid #e5e7eb",
    borderRadius: "0.9rem",
    overflow: "hidden",
    backgroundColor: "var(--color-neutral)",
    "& .paye-table": {
      overflowX: "auto",
    },
    "& .paye-table table": {
      width: "100%",
      borderCollapse: "separate",
      borderSpacing: 0,
      minWidth: "950px",
    },
    "& .paye-table th": {
      backgroundColor: "var(--color-primary-hover)",
      color: "var(--color-primary)",
      borderBottom: "1px solid #e5e7eb",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      padding: "0.8rem 1rem",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      fontSize: "0.8rem",
      minWidth: "unset",
      fontWeight: 700,
      textAlign: "left",
    },
    "& .paye-table tbody": {
      "& tr": {
        borderBottom: "1px solid #e5e7eb",
        "&:last-child": {
          borderBottom: "none",
        },
        "&:hover": {
          backgroundColor: "var(--color-background)",
        },
      },
      "& td": {
        border: "none",
        borderBottom: "1px solid #edf1f6",
        color: "var(--color-text)",
        padding: "0.95rem 1rem",
        minWidth: "unset",
        fontSize: "0.88rem",
        verticalAlign: "middle",
      },
      "& .employee-cell": {
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
        "& .avatar": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "34px",
          height: "34px",
          borderRadius: "50%",
          background:
            "linear-gradient(135deg, var(--color-tertiary) 0%, var(--color-tertiary) 50%, var(--color-secondary) 100%)",
          color: "#FFFFFF",
          fontWeight: 700,
          fontSize: ".72rem",
          flexShrink: 0,
        },
        "& .employee-meta": {
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
        },
        "& .employee-name": {
          fontWeight: 600,
          color: "var(--color-text)",
        },
        "& .employee-caption": {
          fontSize: "12px",
          color: "var(--color-text-light)",
        },
      },
      "& .tax-id": {
        display: "inline-flex",
        padding: "0.2rem 0.55rem",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "var(--color-text)",
      },
      "& .paye-badge": {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0.2rem 0.55rem",
        borderRadius: "999px",
        fontSize: "12px",
        fontWeight: 700,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        backgroundColor: "#E8F5E9",
        color: "var(--color-primary)",
      },
    },
  };
});
